import SocialMedia from 'components/sidebar/SocialMedia'
import { useStateContext } from 'context/StateContext'
import { useState } from 'react'
import { Helmet } from 'react-helmet-async';


const initialState = {
    full_name: "",
    email: "",
    subject: "",
    message: "",
}

export default function Contact() {
    const { darkMode, handleButtonSound } = useStateContext()
    const [state, setState] = useState(initialState)

    // handle change
    const handleChange = e => {
        setState(s => ({ ...s, [e.target.name]: e.target.value }))
    }

    // handle submit
    const handleSubmit = e => {
        e.preventDefault();

        let messageAlert = `
            Full Name: ${state.full_name}
            Email: ${state.email}
            Subject: ${state.subject}
            Message: ${state.message}
        `
        alert(messageAlert)
        setState(initialState)
    }

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title>Steven Eric | Contact</title>
            </Helmet>
            <div className='container' id='contact-section' data-aos="fade-right">
                <div className="row py-4 ">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>CONTACT</h1>
                        <h4 className='position-absolute align-self-center'>Let's Connect</h4>
                    </div>
                </div>

                {/* contact details */}
                <div className="row row-cols-1 row-cols-lg-2 mb-5 px-2 px-md-5 py-3">
                    <div className="col mt-4">
                        <h2 className='fw-bold'>Get in touch</h2>
                        <p className='my-4'>I'm currently avaliable to take on new projects, so feel free to send me a message about anything that you want to run past me. You can contact anytime.</p>
                        <div>
                            <a className='text-info' href="#">(415)&nbsp;555&#8209;0132</a>
                        </div>
                        <div className="my-2">
                            <a className='text-info' href="#">abc@gmail.com</a>
                        </div>
                        <div className='pb-3'>
                            <a className='text-info' href="#">Kingston, New York 12401</a>
                        </div><hr />
                        <div className='mt-4'>
                            <SocialMedia justifyContent={"evenly"} />
                        </div>
                    </div>
                    {/* contact form */}
                    <div className="col mt-5 mt-lg-2">
                        <div className="card border-0 shadow-lg p-4">
                            <form onSubmit={handleSubmit}>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control border-0 text-info shadow-none bg-body-secondary`} id="full_name" onChange={handleChange} value={state.full_name} name='full_name' placeholder="Full name" required minLength={5} />
                                    <label className='text-secondary' htmlFor="full_name">Full Name</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="email" className={`form-control border-0 text-info shadow-none bg-body-secondary`} id="floatingInput" onChange={handleChange} value={state.email} name='email' placeholder="name@example.com" required />
                                    <label className='text-secondary' htmlFor="floatingInput">Email Address</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control border-0 text-info shadow-none bg-body-secondary`} id="subject" onChange={handleChange} value={state.subject} name='subject' placeholder="subject" required minLength={5} />
                                    <label className='text-secondary' htmlFor="subject">Subject</label>
                                </div>
                                <div className="form-floating">
                                    <textarea className={`form-control border-0 text-info shadow-none bg-body-secondary`} placeholder="message" onChange={handleChange} value={state.message} name='message' id="floatingTextarea2" style={{ height: 150 }} required minLength={10}></textarea>
                                    <label className='text-secondary' htmlFor="floatingTextarea2">Type Your Message</label>
                                </div>
                                <div className='mt-3'>
                                    <button type='submit' className='btn btn-info button-stylling px-5 py-2' onClick={handleButtonSound}>Send Message</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

                {/* map */}
                <div className="row px-2 px-md-5 mb-5">
                    <div className="col">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52887706.14540557!2d-161.74454347928352!3d35.99563672201457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2s!4v1705690652174!5m2!1sen!2s" className='w-100 rounded-3 shadow-lg' width="600" height="450"  allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div >
        </>
    )
}
